<ul class="unstyled">
    <li>
        <span
            >{{ address().street }} {{ address().houseNumber
            }}{{ address().houseNumberSuffix ? '-' + address().houseNumberSuffix : '' }}</span
        >
    </li>
    <li>
        <span>{{ address().postalCode }} {{ address().city }}</span>
    </li>
    <li><ap-content key="address.result.nl"></ap-content></li>
</ul>
